import { FEE_FAQ_TEXT } from "./feePolicy";

export const BRAND = {
  name: "Crew Connect FinInvesto",
  shortName: "Crew Connect",
  tagline: "Connecting Businesses and Financiers",
  phone: "+918447867463",
  phoneDisplay: "+91 84478 67463",
  whatsapp: "918447867463",
  email: "support@crewconnectfininvesto.com",
  address: "1209, 12th Floor, Pearls West Heights, NSP, Delhi - 110034",
  website: "www.crewconnectfininvesto.com",
  logo: "/images/logo.png",
  watermark: "/images/footer-brandmark.png",
  logoAlt: "Crew Connect FinInvesto - Connecting Businesses and Financiers",
};

export const IMAGES = {
  hero: "/images/simg-7.jpg",           // handshake + city skyline
  handshake: "/images/simg-3.jpg",      // handshake + workspace
  approval: "/images/simg-1.jpg",       // loan blocks + LOAN APPROVED
  team: "/images/simg-2.jpg",           // team meeting
  financiers: "/images/corporate-financiers.jpg",
  familyMeeting: "/images/simg-4.jpg",  // in-home consult + business loan approved
  wealth: "/images/simg-5.jpg",         // woman on wallet
  keys: "/images/simg-6.jpg",           // house keys
};

export const LOAN_TYPES = [
  "Secured Business Loan",
  "Unsecured Business Loan",
  "Corporate Funding",
  "Structured Funding",
  "Asset-Based Funding",
  "Project Funding",
  "Working Capital Solutions",
  "OD/CC Limits",
  "Supply Chain Finance",
  "Term Loans",
  "Business Expansion Loans",
  "Loan Against Property (LAP)",
  "MSME / SME Loan",
  "Plant & Machinery Loans",
  "MSME & SME Loans",
  "Project Loans",
  "Agriculture Loans",
  "Women Entrepreneur Loans",
  "Sanjivini Loans",
  "EDFS",
  "Home Loan",
  "Trade Finance (LC, BG, SBLC)",
  "CGTMSE / Collateral-Free",
  "Investment Consultancy",
  "Other",
];

export const SERVICES = [
  {
    id: "corporate",
    no: "01",
    title: "Corporate & Industrial Funding",
    badge: "Secured / Unsecured",
    desc: "Targeted solutions for mid-corporate industries and established businesses.",
    rows: [
      { region: "Delhi NCR", ticket: "₹5 Cr – ₹100 Cr", min: "₹100 Cr+" },
      { region: "Mumbai", ticket: "₹20 Lakh – ₹10 Cr", min: "₹5 Cr+" },
      { region: "Lucknow / Varanasi", ticket: "Up to ₹50 Lakh", min: "₹1 Cr+" },
      { region: "Major Cities", ticket: "₹1 Cr – ₹100 Cr", min: "₹50 Cr+" },
    ],
    highlights: [
      "Low CIBIL (solution available)",
      "Monthly EMI (Principal + Interest)",
      "Same-day closure options for durable deals",
    ],
    profiles: ["Manufacturers", "Builders", "Traders", "Aviation", "NBFCs", "NSE/BSE Listed"],
  },
  {
    id: "secured",
    no: "02",
    title: "Secured Private Finance",
    badge: "Asset-Based",
    desc: "High-value secured funding for urgent liquidity and complex projects.",
    rows: [
      { region: "Mumbai LAP", ticket: "₹50 Lakh – ₹25 Cr", min: "Clear-title freehold" },
      { region: "Large Project (Pan-India)", ticket: "₹50 Cr – No upper limit", min: "30-day process" },
      { region: "Medium Ticket Projects", ticket: "₹30 Cr+", min: "Up to 10-yr tenure" },
      { region: "Delhi NCR Boundary (90km)", ticket: "₹25 Lakh – ₹1.5 Cr", min: "13-year records" },
    ],
    highlights: [
      "NPA and bank-rejected files accepted",
      "Low CIBIL (solution available) on secured products",
      "Open plots and cash-income files considered in boundary zone",
    ],
    profiles: ["Builders", "Land Owners", "Project Developers", "Industrial Borrowers"],
  },
  {
    id: "banking",
    no: "03",
    title: "Banking & NBFC Services",
    badge: "Institutional",
    desc: "Standard institutional products for healthy and growth-stage business profiles.",
    rows: [
      { region: "Working Capital", ticket: "OD / CC Limits", min: "Eligible operating entities" },
      { region: "Government Schemes", ticket: "CGTMSE", min: "Policy-based" },
      { region: "Retail Loan Stack", ticket: "Home, Personal, LAP", min: "Profile dependent" },
      { region: "Trade Finance", ticket: "LC, BG, SBLC, PBG, Machine Loans", min: "Business profile based" },
    ],
    highlights: [
      "Threshold: CIBIL 750+",
      "Min Turnover: ₹1 Cr (Delhi NCR) / ₹10 Cr (Other Cities)",
    ],
    profiles: ["SMEs", "Mid-Corporates", "Import-Export Traders", "Capex-focused Firms"],
  },
  {
    id: "cgtmse",
    no: "04",
    title: "Specialized CGTMSE & Financial Solutions",
    badge: "Collateral-Free",
    desc: "Deviation-friendly CGTMSE structuring plus institutional funding for education and NBFC/SFB sectors.",
    rows: [
      { region: "CGTMSE Funding (Standard)", ticket: "Up to ₹2 Cr", min: "Comfortable approvals" },
      { region: "CGTMSE Funding (Case-to-Case)", ticket: "Up to ₹10 Cr", min: "Subject to lender review" },
      { region: "Education Sector Funding", ticket: "Schools / Colleges / Universities", min: "Hostels with 1000+ beds" },
      { region: "NBFC / SFB Funding (via NCDs)", ticket: "Min AUM ₹250 Cr", min: "PAT ₹5-10 Cr, Secured book only" },
    ],
    highlights: [
      "Overleveraged borrowers with DSCR 0.25 - 0.70 accepted",
      "Overleveraged borrowers with FOIR up to 500%",
      "Complete Start-Up (Greenfield) Machinery Loans",
      "No property ownership (both rented) cases accepted",
      "Unaudited financials & business vintage under 1 year",
      "Dip in turnover and CMR up to 6 with CIBIL 720+",
    ],
    profiles: ["Start-Ups", "Greenfield Manufacturers", "Educational Institutions", "NBFCs"],
  },
  {
    id: "supply-chain",
    no: "05",
    title: "Supply Chain Finance & Invoice Discounting",
    badge: "Working Capital & Trade FX",
    desc: "Unique Trade FX integrated offering along with digital regulatory submissions. Seamless Finance Solutions for efficient liquidity management and higher financial benefits.",
    productColumn: "Product",
    rows: [
      { region: "Sales Bill Discounting / Purchase Bill Discounting", ticket: "Upto ₹5 Cr", min: "Quick digital approvals" },
      { region: "Vendor Finance", ticket: "Up to ₹10 Cr", min: "Subject to corporate & anchor review" },
      { region: "Invoice Discounting (Without Recourse)", ticket: "Min AUM ₹1 Cr", min: "Robust debtor profile required" },
    ],
    highlights: [
      "Simplified digital process flows",
      "Paperless transactions on our Online Portal",
      "Receivable purchase from corporate, with OR without recourse",
      "Immediate payment need / prevent blocked discounts",
      "Smart working capital | Better cash flow | Stronger growth",
    ],
    profiles: ["Manufacturers", "Traders", "Import Export Traders", "SMEs", "Mid Corporate", "Suppliers", "Vendors"],
  },
  {
    id: "home-loan",
    no: "06",
    title: "Home Loan / Loan Against Property",
    badge: "Retail",
    desc: "Higher Loan Eligibility Program & Comprehensive Home Loan Solutions across India.",
    rows: [
      { region: "Ticket Size (Pan-India)", ticket: "₹10 Lakh – ₹10 Cr", min: "Salaried / SENP / NRI" },
      { region: "Top-Up (up to ₹30L)", ticket: "85% LTV", min: "100% Top-up on same ROI (20 yrs)" },
      { region: "Top-Up (₹30L – ₹75L)", ticket: "80% LTV", min: "MOB: 3 (BT) / 9 (BT + Top-up)" },
      { region: "Top-Up (₹75L – ₹5 Cr)", ticket: "75% LTV", min: "Salaried BT: 20% of original sanction" },
      { region: "Top-Up (> ₹5 Cr)", ticket: "70% LTV", min: "Case-specific structuring" },
    ],
    highlights: [
      "Core Advantage: 140% funding on Plot + Built House (70% market value each)",
      "SENP: Verified income FOIR 100% (≤30L) / 150% (30L – 300L)",
      "NRI Salaried: Min ₹1L – Max ₹3 Cr, 60% FOIR, 70% combined LTV",
      "BT Track Multipliers: 12-18 EMI (1.1x) → >36 EMI (1.4x)",
    ],
    profiles: ["Salaried", "SENP", "NRI", "Balance Transfer", "Top-Up Seekers"],
  },
  {
    id: "retail",
    no: "07",
    title: "Retail & Professional Solutions",
    badge: "Salaried & Partners",
    desc: "Funding support for salaried professionals and strategic channel partners.",
    rows: [
      { region: "Salaried Employees", ticket: "Salary ₹25k+", min: "36-month tenure" },
      { region: "Professional Connect", ticket: "CA / CMA / CFO / CEO", min: "Referral cooperation" },
    ],
    highlights: [
      "Both-side rented residences accepted",
      "Ideal for CA, CMA, CFO, CEO and proprietors",
      "Fast-track support for urgent profiles",
    ],
    profiles: ["Salaried Employees", "Financial Consultants", "Corporate Advisors", "Practice Owners"],
  },
  {
    id: "investment",
    no: "08",
    title: "Investment Consultancy",
    badge: "Advisory",
    desc: "Advisory on Stock Investments and Real Estate for HNI and business clients.",
    rows: [
      { region: "Stock Investment – Listed", ticket: "Equity", min: "Growth portfolios" },
      { region: "Stock Investment – Unlisted", ticket: "Equity / Bonds & Debt / Stock Lending", min: "Private placements" },
      { region: "Real Estate – Residential / Commercial / Multiuse", ticket: "Land / House / Flat / Villa", min: "Direct or fractional" },
      { region: "Real Estate – Alternative", ticket: "Crowd Funding / Lease Income / House Flipping", min: "Yield & flip strategies" },
    ],
    highlights: [
      "Listed & Unlisted equity structuring",
      "Bonds, debentures and stock-lending desk",
      "Residential, commercial and multiuse property advisory",
      "Real-estate investment via crowd funding, lease income and house flipping",
    ],
    profiles: ["HNIs", "Family Offices", "Corporate Treasuries", "NRIs"],
  },
];

export const LOAN_PRODUCTS = [
  { id: "plant-machinery", name: "Plant & Machinery Loans", desc: "Equip your next phase of growth", icon: "Factory", colors: ["#b82336", "#7d1526"] },
  { id: "working-capital", name: "Working Capital Solutions", desc: "OD/CC Limits", icon: "Wallet", colors: ["#1557cf", "#123b88"] },
  { id: "od-cc", name: "OD/CC Limits", desc: "Liquidity for everyday business needs", icon: "Landmark", colors: ["#303740", "#151b23"] },
  { id: "supply-chain", name: "Supply Chain Finance", desc: "Turn receivables into opportunity", icon: "Network", colors: ["#09776f", "#074b52"] },
  { id: "term-loans", name: "Term Loans", desc: "Long-term capital. Confident planning.", icon: "CalendarRange", colors: ["#a02b5b", "#671c41"] },
  { id: "business-expansion", name: "Business Expansion Loans", desc: "Capital for your next big move", icon: "TrendingUp", colors: ["#3447aa", "#202f73"] },
  { id: "msme-sme", name: "MSME & SME Loans", desc: "Empowering Small & Medium Enterprises", icon: "Briefcase", colors: ["#8f2631", "#571a28"] },
  { id: "project", name: "Project Loans", desc: "Funding Your Big Ideas", icon: "Building2", colors: ["#006b92", "#03435e"] },
  { id: "agriculture", name: "Agriculture Loans", desc: "Supporting Farmers' Growth", icon: "Sprout", colors: ["#267342", "#164e33"] },
  { id: "women-entrepreneur", name: "Women Entrepreneur Loans", desc: "Empowering Women in Business", icon: "Award", colors: ["#a52e46", "#6b1937"] },
  { id: "sanjivini", name: "Sanjivini Loans", desc: "Healthcare & Emergency Funding", icon: "HeartPulse", colors: ["#20627b", "#133a51"] },
  { id: "edfs", name: "EDFS", desc: "Export & Development Finance", icon: "Plane", colors: ["#454b57", "#282d38"] },
];

export const WHY_US = [
  { title: "NPA & Technical Rejections", desc: "We fund cases others won't. Bank-rejected files welcome." },
  { title: "Low CIBIL Specialists", desc: "Low CIBIL (solution available) — especially on secured products." },
  { title: "Speed of Closure", desc: "Emergency short-term funding with rapid, same-day closures." },
  { title: "No Margin? No Problem.", desc: "Solutions available for project loans lacking margin money." },
  { title: "Pan-India Reach", desc: "Active across Delhi NCR, Mumbai, Lucknow, Pune, Bengaluru and more." },
  { title: "Direct Lender Access", desc: "Nationalized Banks, NBFCs, and Private Institutional Funding partners." },
];

export const CHALLENGES = [
  "Low CIBIL score (solution available)",
  "Cases rejected due to technical reasons",
  "Cases rejected due to income-related issues",
  "Cases rejected due to lack of eligibility",
  "Project loan cases rejected due to lack of margin money",
  "NPA with running business and cash flow welcome",
];

export const CORE_VALUES = [
  {
    title: "Collaborative",
    desc: "Build strong ties with internal and external partners.",
    icon: "Users",
  },
  {
    title: "Empowered",
    desc: "Trust staff to handle hard tasks and share authority.",
    icon: "Zap",
  },
  {
    title: "Decisive",
    desc: "Make smart and well-informed choices.",
    icon: "Target",
  },
  {
    title: "Innovative",
    desc: "Find new ways to help the customer.",
    icon: "Lightbulb",
  },
];

export const FAQ = [
  {
    q: "Is Crew Connect FinInvesto a bank or a lender?",
    a: "No. We are a financial consultancy and facilitator. We connect businesses with banks, NBFCs and private institutional financiers. Final approval, terms and disbursement rest with the lender.",
  },
  {
    q: "What is your fee structure?",
    a: FEE_FAQ_TEXT,
  },
  {
    q: "Do you handle low-CIBIL or NPA cases?",
    a: "Yes. Low CIBIL (solution available) — especially for secured products. We also fund NPA files with a running business and cash flow, as well as cases rejected on technical or income grounds by other lenders.",
  },
  {
    q: "How long does the funding process take?",
    a: "Standard closures range from 2 to 4 weeks. Large-ticket project funding averages a 30-day process. In urgent cases we facilitate same-day closures on qualifying deals.",
  },
  {
    q: "What ticket sizes do you handle?",
    a: "From ₹10 Lakh retail home loans to ₹50 Cr+ project funding with no upper limit for large infrastructure deals. Corporate & industrial funding typically ranges ₹5 Cr – ₹100 Cr.",
  },
  {
    q: "Do you offer investment consultancy?",
    a: "Yes. Our advisory desk covers stock investments (listed and unlisted equity, bonds/debt and stock lending) and real estate (residential, commercial, multi-use, crowd funding, lease income and house flipping).",
  },
  {
    q: "What documents are required?",
    a: "Typically KYC (PAN, Aadhaar), 2–3 years financials/ITR, bank statements, GST returns, property documents (for secured), and a brief business profile. Exact list depends on the product and lender.",
  },
  {
    q: "Is my information confidential?",
    a: "Yes. All financial data and proprietary information is treated as strictly confidential and shared only with lenders whose review is necessary — never with third parties without written consent, except where required by law.",
  },
  {
    q: "Where are you located and which jurisdiction applies?",
    a: "Our office is at 1209, 12th Floor, Pearls West Heights, NSP, Delhi 110034. Our engagement mandate is governed by the laws of India, with exclusive jurisdiction in the courts of Delhi.",
  },
];
